import uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import RadioButton from 'app/components/shared/RadioButton';

import './PrivacyField.scss';

const PRIVACY_TYPE = { ALL: 'ALL_ITEMS', PRIVATE: 'IS_PRIVATE', SHARED: 'IS_SHARED' };

export default function PrivacyField({ handleToggleFilter, filters }) {
  let privacyType;
  if (filters.size > 1) {
    privacyType = PRIVACY_TYPE.ALL;
  } else {
    privacyType = filters.getIn([0, 'value']) === 'true' ? PRIVACY_TYPE.PRIVATE : PRIVACY_TYPE.SHARED;
  }

  const sharedInputName = uniqueId('select-privacy-type_');

  function handleChange(type) {
    let filter;
    switch (type) {
      case PRIVACY_TYPE.SHARED: {
        filter = Immutable.Map({ value: 'false' });
        break;
      }
      case PRIVACY_TYPE.PRIVATE: {
        filter = Immutable.Map({ value: 'true' });
        break;
      }
      default: {
        filter = Immutable.Map({ value: undefined });
        break;
      }
    }
    handleToggleFilter('IS_PRIVATE', filter, true);
  }

  return (
    <div className="cp-privacy-field">
      <h4 className="field-name">
        <FormattedMessage id="section_title_item_privacy" />
      </h4>
      <ul className="privacy-types-list">
        {Object.keys(PRIVACY_TYPE).map(type => {
          const id = uniqueId(`select-${type}_`);

          return (
            <li key={`select-${type}-item`}>
              <RadioButton
                checked={privacyType === PRIVACY_TYPE[type]}
                dataKey={id}
                handleChange={handleChange}
                id={id}
                label={<FormattedMessage id={`${PRIVACY_TYPE[type]}.field`} />}
                name={sharedInputName}
                value={PRIVACY_TYPE[type]}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

PrivacyField.propTypes = {
  handleToggleFilter: PropTypes.func.isRequired,
  filters: ImmutablePropTypes.list.isRequired
};
